module.exports = __webpack_public_path__ + "static/media/260-united-kingdom.e57539d2.svg";